// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_item__c0fzV {
  display: flex;
  align-items: center;
  padding: 8px 0;
  justify-content: space-between;
}
.style_item__part__2EU5X {
  color: rgb(27, 27, 27);
  width: 62%;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  gap: 5px;
}
.style_item__part__right__sZuNr {
  display: flex;
  width: 37%;
  justify-content: flex-end;
  font-size: 1.5rem !important;
}
.style_item__avatar__q-UTj {
  width: 22px;
  height: 22px;
  border: 1px solid rgb(255, 199, 1);
  border-radius: 100px;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_item__avatar__q-UTj p {
  color: rgb(213, 212, 220);
}
.style_item__level__0G2XO {
  color: rgb(117, 83, 240);
  font-size: 1.6rem;
  font-weight: 600;
}
.style_item__username__uOIPq {
  color: rgb(27, 27, 27);
  font-size: 1.6rem;
  font-weight: 600;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.style_empty__referrals__asmzx {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.style_balance__iGibi {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
}
.style_balance__amount__TpAQZ {
  display: flex;
  gap: 6px;
}
.style_balance__icon__W7PQz {
  width: 18px;
  height: 18px;
  border-radius: 100px;
  background: #fdc902;
}
.style_balance__icon__W7PQz img {
  width: 100%;
  height: 100%;
}
.style_balance__value__F7Ww5 {
  font-size: 1.5rem;
  color: rgb(27, 27, 27);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/features/referrals/referrals-list/users/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;AADF;AAEE;EACE,sBCNU;EDOV,UAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAJ;AACI;EACE,aAAA;EACA,UAAA;EACA,yBAAA;EACA,4BAAA;AACN;AAGE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,oBAAA;EACA,8BCtBI;EDuBJ,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAEI;EACE,yBC1BO;AD0Bb;AAGE;EACE,wBCpCG;EDqCH,iBAAA;EACA,gBAAA;AADJ;AAGE;EACE,sBCvCU;EDwCV,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIE;EACE,aAAA;EACA,QAAA;AAFJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAIE;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;AAFJ","sourcesContent":["@import '../../../../../public/assets/colors';\n\n.item {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  justify-content: space-between;\n  &__part {\n    color: $black-extra;\n    width: 62%;\n    justify-content: flex-start;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    &__right {\n      display: flex;\n      width: 37%;\n      justify-content: flex-end;\n      font-size: 1.5rem !important;\n    }\n  }\n\n  &__avatar {\n    width: 22px;\n    height: 22px;\n    border: 1px solid $yellow;\n    border-radius: 100px;\n    background: $white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    p {\n      color: $light-grey;\n    }\n  }\n  &__level {\n    color: $main;\n    font-size: 1.6rem;\n    font-weight: 600;\n  }\n  &__username {\n    color: $black-extra;\n    font-size: 1.6rem;\n    font-weight: 600;\n    max-width: 120px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.empty__referrals {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n.balance {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 6px;\n\n  &__amount {\n    display: flex;\n    gap: 6px;\n  }\n  &__icon {\n    width: 18px;\n    height: 18px;\n    border-radius: 100px;\n    background: #fdc902;\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  &__value {\n    font-size: 1.5rem;\n    color: rgba(27, 27, 27, 1);\n    font-weight: 700;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `style_item__c0fzV`,
	"item__part": `style_item__part__2EU5X`,
	"item__part__right": `style_item__part__right__sZuNr`,
	"item__avatar": `style_item__avatar__q-UTj`,
	"item__level": `style_item__level__0G2XO`,
	"item__username": `style_item__username__uOIPq`,
	"empty__referrals": `style_empty__referrals__asmzx`,
	"balance": `style_balance__iGibi`,
	"balance__amount": `style_balance__amount__TpAQZ`,
	"balance__icon": `style_balance__icon__W7PQz`,
	"balance__value": `style_balance__value__F7Ww5`
};
export default ___CSS_LOADER_EXPORT___;
